import type { HTMLAttributes } from "react"

export function Rail({ orientation = "horizontal", style, ...rest }: HTMLAttributes<HTMLDivElement> & { orientation?: "horizontal" | "vertical" }) {
  const baseStyle =
    orientation === "horizontal"
      ? { height: "2px", width: "100%", background: "var(--rail)" }
      : { width: "2px", height: "100%", background: "var(--rail)" }

  return <div {...rest} style={{ ...baseStyle, ...style }} aria-hidden />
}

export default Rail
